/**
 * SubscriptionDiscountSettingsCtrl controller
 */
import { SUBSCRIPTION_PRODUCT_TYPES_FOR_DISCOUNT } from '../../app/core/constants'
import { getFilteredKeys } from '../common/directives/contentItems/ciHelpers'
// preload drag'n'drop image
const dragndropImg = new window.Image()
dragndropImg.src = require('./img/dragndrop.png')
/**
 * SubscriptionDiscountSettingsCtrl controller
 *
 * @class SubscriptionDiscountSettingsCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:SubscriptionDiscountSettingsCtrl
 */
/* @ngInject */
export default function SubscriptionDiscountSettingsCtrl ($scope, subscription, scope) {
  const vm = this

  /**
   * Subscription
   *
   * @memberof mwApp/packages.controller:SubscriptionDiscountSettingsCtrl
   * @type {models.Subscription}
   */
  vm.subscription = subscription
  vm.paidContentSetsArr = []
  vm.conditionItem = undefined
  vm.conditionItems = {
    CONTENT_ADDON: [],
    ACCESSORY: vm.subscription.assignedAccessories
  }

  vm.discountsProductTypes = SUBSCRIPTION_PRODUCT_TYPES_FOR_DISCOUNT

  vm.targetProductsTypes = { CONTENT_ADDON: 'contentAddon', ACCESSORY: 'accessory' }

  vm.getFilteredKeys = getFilteredKeys

  vm.generateRuleName = function (index, productType, pricingRule, value) {
    return 'Rule ' + (index + 1) + ' for ' + ((productType === 'CONTENT_ADDON' && pricingRule?.contentAddon?.name) || (productType === 'ACCESSORY' && pricingRule?.accessory?.name) || value)
  }

  vm.onOffRule = function (rule, event, form, index) {
    event.preventDefault()
    event.stopPropagation()

    rule.enabled = !rule.enabled

    vm.validateRules(rule, { form, index })

    form.$setDirty()
  }

  vm.isAddRuleButtonDisabled = function (productType) {
    if (productType === 'SUBSCRIPTION') {
      return !(vm.conditionItems.CONTENT_ADDON.length || vm.conditionItems.ACCESSORY.length)
    } else {
      return !vm.conditionItems[productType].length
    }
  }

  vm.disableConditionItemChoice = function (pricingRule, conditionContentSet) {
    if (pricingRule.productType === pricingRule.conditionProductType) {
      const discountedProductId = (pricingRule.conditionProductType === 'ACCESSORY' && pricingRule.accessory?.id) || (pricingRule.conditionProductType === 'CONTENT_ADDON' && pricingRule.contentAddon?.id)
      if (conditionContentSet?.id === discountedProductId) {
        return true
      }
    }
    return false
  }

  vm.disableDiscountedProductChoice = function (pricingRule, discountedProduct) {
    if (pricingRule.productType === pricingRule.conditionProductType) {
      return pricingRule.$conditionItems.filter(item => item.id === discountedProduct.id).length
    }
    return false
  }

  vm.addNewRule = function (productType) {
    const arr = vm.subscription['$pricingRules' + productType]

    const sortOrder = arr.length ? arr[arr.length - 1].sortOrder + 1 : 0
    const newRule = {
      conditionProductType: 'CONTENT_ADDON',
      productType,
      sortOrder,
      enabled: false
    }
    vm.subscription['$pricingRules' + productType].push(newRule)
  }

  vm.getConditionItems = function (rule, form, index) {
    const validateRules = () => {
      if (form) {
        vm.validateRules(rule, { form, index, validateAllRules: true })
      }
    }

    if (rule.conditionProductType === 'CONTENT_ADDON') {
      if (!rule.conditionContentAddons) {
        rule.conditionContentAddons = []
      }
      rule.$conditionItems = rule.conditionContentAddons
      rule.conditionAccessories = []
      validateRules()
      return
    }

    if (rule.conditionProductType === 'ACCESSORY') {
      if (!rule.conditionAccessories) {
        rule.conditionAccessories = []
      }
      rule.$conditionItems = rule.conditionAccessories
      rule.conditionContentAddons = []
      validateRules()
      return
    }

    rule.$conditionItems = []
    validateRules()
  }

  vm.onSelectConditionProductType = function (rule, form, index) {
    rule.$conditionItems.push(vm.conditionItem)
    vm.validateRules(rule, { form, index, validateAllRules: true })
    vm.conditionItem = undefined
  }

  vm.onDeselectConditionItem = function (pricingRule, index, form) {
    pricingRule.$conditionItems.splice(index, 1)
    vm.validateRules(pricingRule, { form })
    const fieldName = 'conditionPriceSettings_' + pricingRule?.productType + '_' + index + '_conditionItems'

    form[fieldName].$setTouched()
    form.$setDirty()
  }

  vm.rulesWatcher = scope.discountSettingsRulesWatcher = function (watchedArr, type) {
    for (const productType in vm.discountsProductTypes) {
      const pricingRules = vm.subscription['$pricingRules' + productType]
      const rulesForRemoving = []
      for (let i = 0; i < pricingRules?.length; i++) {
        const pricingRule = pricingRules[i]

        if (type === productType) {
          const discountedProductId = (productType === 'ACCESSORY' && pricingRule.accessory?.id) || (productType === 'CONTENT_ADDON' && pricingRule.contentAddon?.id)

          if (!discountedProductId) return

          const isPresent = watchedArr.some(item => item.id === discountedProductId)
          if (!isPresent) {
            rulesForRemoving.push(i)
            continue
          }
        }

        if (pricingRule.conditionProductType === type) {
          if (pricingRule.$conditionItems?.length === 1) {
            const id = pricingRule.$conditionItems[0].id
            const isPresent = watchedArr.some(item => item.id === id)
            if (!isPresent) {
              rulesForRemoving.push(i)
              continue
            }
          }

          if (pricingRule.$conditionItems?.length > 1) {
            const localItemsForRemoving = []

            pricingRule.$conditionItems.forEach(({ id }, index) => {
              !watchedArr.some(item => item.id === id) && localItemsForRemoving.push(index)
            })

            if (localItemsForRemoving.length) {
              localItemsForRemoving.reverse().forEach(i => pricingRule.$conditionItems.splice(i, 1))
              pricingRule.enabled = false

              // set off rule validation
              const field = 'conditionPriceSettings_' + productType + '_' + i + '_ruleEnable' + '_forValidation'
              $scope.form[field] && $scope.form[field].$setValidity('duplicate', true)
            }

            if (!pricingRule.$conditionItems?.length) {
              rulesForRemoving.push(i)
            }
          }
        }
      }

      rulesForRemoving.reverse().forEach(i => pricingRules.splice(i, 1))
    }
  }

  vm.getConditionItemsList = scope.getConditionItemsList =
    function (next = vm.subscription.paidContentSets.channelSets) {
      vm.conditionItems.CONTENT_ADDON = next?.filter(set => set?.pricing?.rent?.paymentMethod === 'PER_SET') || []
    }

  $scope.$watch('vm.subscription.paidContentSets.channelSets', vm.getConditionItemsList)

  $scope.$watch('vm.conditionItems.CONTENT_ADDON', (next) => {
    vm.rulesWatcher(next, 'CONTENT_ADDON')
  })

  $scope.$watch('vm.subscription.assignedAccessories', (next) => {
    vm.conditionItems.ACCESSORY = next
  })

  $scope.$watch('vm.conditionItems.ACCESSORY', (next, old) => {
    vm.rulesWatcher(next, 'ACCESSORY')
  })

  vm.returnOriginalPrice = function (pricingRule) {
    if (pricingRule.productType === 'SUBSCRIPTION') {
      return vm.subscription.baseAmount.amount
    }

    if (pricingRule.productType === 'CONTENT_ADDON') {
      return pricingRule?.contentAddon?.pricing?.rent?.amount || 0
    }

    if (pricingRule.productType === 'ACCESSORY') {
      return pricingRule?.accessory?.amount || 0
    }

    return 0
  }

  vm.deleteRule = function (rules, index, form) {
    const rule = { ...rules.splice(index, 1)[0], enabled: false }
    vm.validateRules(rule, { form, timeout: true })
    form.$setDirty()
  }

  vm.onTargetProductChange = function (rule, form, index) {
    vm.validateRules(rule, { form, index, validateAllRules: true })
  }

  vm.validateRules = function (targetRule, { form, index, validateAllRules = false, timeout = false }) {
    const productType = targetRule?.productType
    const rules = vm.subscription['$pricingRules' + productType]
      .map((rule, index) => ({ ...rule, index }))
      .filter(rule =>
        rule.enabled &&
        (validateAllRules ||
          (
            rule.conditionProductType === targetRule.conditionProductType &&
            rule[vm.targetProductsTypes[productType]]?.id === targetRule[vm.targetProductsTypes[productType]]?.id
          )
        )
      )

    if (index !== undefined && (!targetRule.enabled || targetRule.$conditionItems.length)) {
      const field = 'conditionPriceSettings_' + productType + '_' + index + '_ruleEnable' + '_forValidation'
      form[field] && form[field].$setValidity('duplicate', true)
    }

    const prepareRuleForCompare = (rule) =>
      JSON.stringify(rule.$conditionItems.map(r => r.id).sort((a, b) => a - b)) +
      rule.conditionProductType + rule[vm.targetProductsTypes[productType]]?.id

    const rulesForCompare = rules.map(prepareRuleForCompare)

    for (const rule of rules) {
      const field = 'conditionPriceSettings_' + productType + '_' + rule.index + '_ruleEnable' + '_forValidation'
      const ruleForCompare = prepareRuleForCompare(rule)
      const condition = rulesForCompare.filter(rule => rule === ruleForCompare).length < 2

      if (timeout) {
        setTimeout(() => { form[field].$setValidity('duplicate', condition) }, 1)
      } else {
        form[field].$setValidity('duplicate', condition)
      }
    }
  }

  // drag-n-drop

  /**
   * dnd-dragging determines what data gets serialized and send to the receiver
   * of the drop. While we usually just send a single object, we send the array
   * of all selected items here.
   */
  vm.getSelected = function (list, item) {
    item.selected = true
    return list.rules.filter(item => item.selected)
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragstart = function (list, event) {
    list.dragging = true
    if (event.dataTransfer.setDragImage) {
      event.dataTransfer.setDragImage(dragndropImg, 0, 0)
    }
  }

  /**
   * Last but not least, we have to remove the previously dragged items in the
   * dnd-moved callback.
   */
  vm.onMoved = function (list, form) {
    const arr = list.rules.filter((item) => !item.selected)
    list.rules.length = 0
    list.rules.push(...arr)
    list.rules.forEach((slide, index) => { slide.sortOrder = index })
    vm.validateRules(list.rules[0], { form, timeout: true, validateAllRules: true })
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragend = function (list) {
    list.dragging = false
  }

  /**
   * In the dnd-drop callback, we now have to handle the data array that we
   * sent above. We handle the insertion into the list ourselves. By returning
   * true, the dnd-list directive won't do the insertion itself.
   */
  vm.onDrop = function (list, items, index, form) {
    if (list.rules[0].productType !== items[0].productType) {
      return false
    }

    form.$setDirty()
    items.forEach(item => { item.selected = false })
    const arr = list.rules.slice(0, index)
      .concat(items)
      .concat(list.rules.slice(index))
    list.rules.length = 0
    list.rules.push(...arr)

    return true
  }
}
